import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface MachineStatusProps {
  status: {
    color: string;
    value: string;
  };
}

const MachineStatus = ({ status }: MachineStatusProps) => {
  const { t } = useTranslation();

  return (
    <Typography
      variant="button"
      style={{
        color: status.color,
        marginRight: '.5rem',
        marginTop: '.2rem',
        fontSize: '.75rem'
      }}
    >
      {t(`machines.status.${status.value.toLowerCase()}`)}
    </Typography>
  );
};

export default MachineStatus;
